




































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import Loading from '@/components/Loading.vue';
import Error from '@/components/Error.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import { EnrolProfile, EnrolProfileActility } from '@/types';
import { ApiClient, curApiClient } from '@/services/ApiClient';


@Component({
  components: {
    Loading,
    Error,
    SectionHeader,
    Success
  },
})
export default class EditEnrolProfile extends Vue {

  @Prop({ default: {},  type: Object}) enrolProfile!: EnrolProfile;

  @Watch("enrolProfile", {immediate:true})
  onEnrolProfile(newValue:EnrolProfile, oldValue:EnrolProfile){

    // we update our model with the start up data
    this.description = newValue.description;
    
    if(newValue.actility)
      this.actility = Object.assign({}, newValue.actility);
  }

  // our model
  error:string = '';
  success:string = '';
  
  description = "";
  actility:EnrolProfileActility = {} as EnrolProfileActility
  
  httpBusy:boolean = false;

  // internal dependencies
  private apiClient:ApiClient = curApiClient;
  
  async mounted() {

  }

  get canUpdate():boolean {
    return !this.httpBusy;
  }

  async update() {

    this.httpBusy = true;

    this.error = '';

    const updateReq = {
      enrolId: this.enrolProfile.enrolId,
      description: this.description,
      actility: this.actility
    }
    
    const reply = await this.apiClient.updateEnrolProfile(updateReq);

    this.httpBusy = false;
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `unable to update enrol profile: ${reply.errorMsg}`;

    this.setSuccess(`Enrol profile ${this.enrolProfile.enrolId} updated successfully`);
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
